import School from './School.page';

export default School;
